import React from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// Custom hooks
import { useAuth } from "hooks/useAuth";

// Layout components
import DashboardLayout from "layouts/DashboardLayout";
import AuthLayout from "layouts/AuthLayout";

function LayoutWrapper({ children }) {
  const { pathname } = useLocation();
  const { isLoggedIn } = useAuth();

  // Check if current route is an authentication page
  const isAuthPage = pathname.startsWith("/authentication");
  
  // Determine which layout to use
  if (isAuthPage) {
    return <AuthLayout>{children}</AuthLayout>;
  }
  
  if (isLoggedIn) {
    return <DashboardLayout>{children}</DashboardLayout>;
  }

  // For unauthenticated non-auth pages, just render children
  // (they will be redirected by ProtectedRoute)
  return children;
}

// Typechecking props for the LayoutWrapper
LayoutWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutWrapper;

